import ApiService from '@/common/api.service';
import * as action from '@/store/action.types';
import { GET_DASHBOARD_EVENTS_URL, GET_DASHBOARD_EXPENSES_URL } from '@/constants/ApiConstants';

const state = {};

const getters = {};

const actions = {
  [action.GET_DASHBOARD_EVENTS](_, data) {
    return ApiService.get(GET_DASHBOARD_EVENTS_URL.replace(':page', data.page).replace(':size', data.size));
  },
  [action.GET_DASHBOARD_EXPENSES](_, data) {
    return ApiService.get(GET_DASHBOARD_EXPENSES_URL.replace(':page', data.page).replace(':size', data.size));
  },
};

export default {
    state,
    actions,
    getters
}